import cancelReservation from './cancelReservation';
import fetchUserReservation from './fetchUserReservation';
import editReservation from './editReservation';
import generatePermit from './generatePermit';
import resendEmail from './resendEmail';

export default [cancelReservation, resendEmail, generatePermit, editReservation, fetchUserReservation];
